export default class CreateAgencyGroupRequest  {
	name = '';  
	agencyUserIds: string[] = [];
}